// import { onSetArrayAnswers, onSetArrayData, onSetArrayHeaders } from "./tableSlice";
import { filters, filterValues, renderColor, sortDate, sortPercentages, sortTime } from "../helpers";
import { TemplateDetailUser } from "../../pages/common";
import { isConnected } from "../../api/api";
import { addNewResponseToLocalServer } from "../../api/toLocalServer";
import { message } from "antd";
import { getAllResponsesTrainingFormProject } from "../VRT/thunks";
import { TrainingAddManyResponses } from "../../api";

export const setDataTable = (payload) => {
	return async (dispatch, getState) => {
		const [headers, responses, ...data] = payload.array;
		console.clear();
		console.log(payload.projectId);
		const headersFormated = setFormatHeaders(headers, responses);
		// const dataFormated = setFormatData(data, headersFormated);
		if (isConnected) {
			// mandarlos al api

			// compatible solo con proyecto de colgate
			if (payload.projectId === "661575328e1587f2f457cd81") {
				// data.pop();
				const dataformatedToSaveLocalDB = [];
				console.log(data);
				data.forEach((reponse) => {
					const responsesFormated = {};
					for (let i = 5; i < reponse.length; i++) {
						responsesFormated[headersFormated[i].dataIndex.replace(/\r/g, "")] = {};
						responsesFormated[headersFormated[i].dataIndex].question = responses[i].replace(/\r/g, "");
						let responseInSeconds = reponse[i].replace(/\r/g, "").split(" ");
						responsesFormated[headersFormated[i].dataIndex].answer = `tiempo:${responseInSeconds[responseInSeconds.length - 1]}`;
						responsesFormated[headersFormated[i].dataIndex].correctAnswer = responses[i].replace(/\r/g, "");
					}
					if (responsesFormated["Lobby"]) {
						dataformatedToSaveLocalDB.push({
							matricula: reponse[0],
							idUser: reponse[0],
							nameUser: reponse[3],
							durationInSeconds: reponse[4],
							projectId: payload.projectId,
							createdAt: reponse[2],
							responses: { ...responsesFormated },
						});
					}
				});
				console.log({
					responses: dataformatedToSaveLocalDB,
				});
				await TrainingAddManyResponses(dataformatedToSaveLocalDB);
				dispatch(getAllResponsesTrainingFormProject(payload.projectId));
			}
		} else {
			//DBlocal save data
			const dataformatedToSaveLocalDB = data.map((reponse) => {
				const responsesFormated = {};
				for (let i = 2; i < reponse.length; i++) {
					responsesFormated[headersFormated[i].dataIndex.replace(/\r/g, "")] = {};
					responsesFormated[headersFormated[i].dataIndex].question = headersFormated[i].dataIndex.replace(/\r/g, "");
					responsesFormated[headersFormated[i].dataIndex].answer = reponse[i].replace(/\r/g, "");
					responsesFormated[headersFormated[i].dataIndex].correctAnswer = responses[i].replace(/\r/g, "");
				}
				return {
					matricula: reponse[0],
					nameUser: reponse[0],
					// TODO
					projectId: "644809cefe068977a9dce3a1",
					durationInSeconds: 120, //TODO
					createdAt: new Date(reponse[1]).toISOString(),
					responses: [responsesFormated],
				};
			});
			const responseapi = await Promise.all(
				dataformatedToSaveLocalDB.map(async (infoToSAve) => {
					return await addNewResponseToLocalServer(infoToSAve);
				})
			);
			const conteo = responseapi.reduce(
				(acc, curr) => {
					if (curr.status === 0) {
						acc.statusCero++;
					} else {
						acc.statusNoCero++;
					}
					return acc;
				},
				{ statusCero: 0, statusNoCero: 0 }
			);
			message.success(`Se agregaron ${conteo.statusCero} resultados`);
			dispatch(getAllResponsesTrainingFormProject(1));
			if (conteo.statusNoCero >= 1) {
				message.error(`Error en ${conteo.statusNoCero} resultados`);
			}
		}
		// dispatch(onSetArrayHeaders(headersFormated));
		// dispatch(onSetArrayAnswers(responses));
		// dispatch(onSetArrayData(dataFormated));
	};
};

const setFormatHeaders = (headers, responses) => {
	const tableHeaders = headers.map((header, i) => {
		const headerFormatted = {
			key: header.trim(),
			dataIndex: header.trim().split(" ").join("_"),
			title: header.trim(),
			width: 200,
            render: (text) => {
                return text.trim().substring(0, 17);
            }
		};
		// .Todo lo que no sea nombre o fecha le asigna los filtros de preguntas (A,B,C,D...)
		if (!["Nombre", "Fecha"].some((headerTitle) => header.includes(headerTitle))) {
			headerFormatted.filters = filters;
			headerFormatted.render = (text) => renderColor(text, responses, i);
			headerFormatted.onFilter = (value, record) => filterValues(value, record, header);
		}

		if (header.includes("Fecha")) {
			headerFormatted.sorter = (a, b) => sortDate(a, b, header);
		}
		return headerFormatted;
	});
	// tablas estaticas que simpre se muestran dependidnod de la carga

	tableHeaders.push({
		dataIndex: "tiempo_total",
		sorter: (a, b) => sortPercentages(a, b, "tiempo_total"),
		key: "tiempo Total",
		title: "Tiempo total",
		fixed: "right",
		width: 150,
	});
	tableHeaders.push({
		dataIndex: "Porcentaje_total",
		sorter: (a, b) => sortTime(a, b, "Porcentaje_total"),
		key: "Porcentaje total",
		title: "Porcentaje total",
		fixed: "right",
		width: 150,
	});
	tableHeaders.push({
		dataIndex: "Detalles",
		title: "Detalles",
		key: "operation",
		fixed: "right",
		width: 100,
		// render: (text, record) => <button onClick={(e) => console.log(e)}>{record.Nombre}</button>,
		render: (text, record) => <TemplateDetailUser nameUser={record.Nombre} />,
	});
	console.log(tableHeaders);
	return tableHeaders;
};

// eslint-disable-next-line
const setFormatData = (data, headersFormated) => {
	data.pop();
	return data.map((row, y) => {
		console.log("/*--*-*-*");
		console.log(row);
		const rowadd = { key: y };
		let correctAnswers = 0;
		let incorrectAnswers = 0;

		row.forEach((element, x) => {
			const header = headersFormated[x];
			const color = header.render && header.render(element).props.style.color;
			rowadd[header.dataIndex] = element;

			if (color === "#459A33") {
				correctAnswers += 1;
			} else if (color === "#B64D34" || color === "#454545") {
				incorrectAnswers += 1;
			}
		});

		const percentage = `${Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100)}%`;
		rowadd["Porcentaje_total"] = percentage;

		return rowadd;
	});
};
